import { StoryState } from '@common/store/story/models/story.models';
import { createFeatureSelector, createSelector } from '@ngrx/store';
import { FullscreenLayoutAreas } from '@src/assets/css/fullscreen.template.scss';
import { ObjectTypes } from '@src/suite/common/enums/object-types';
import { selectFullscreenState } from '@src/suite/common/store/fullscreen';
import { selectSidecarCurrentRundownSelectedStoryGuid, selectSidecarCurrentStoryGuid, selectSidecarCurrentTopicStoryGuid } from '@src/suite/common/store/fullscreen/selectors/sidecar.selectors';

const selectStoryState = createFeatureSelector<StoryState>('stories');
export const selectPrompts = createSelector(selectStoryState, (state: StoryState) => state.prompts);
export const selectSelectedText = (guid: string) =>
    createSelector(selectStoryState, (state: StoryState) => {
        return state?.selectedText.get(guid);
    });

export const selectLockedState = (guid: string) =>
    createSelector(selectStoryState, state => {
        return state.lockState.get(guid);
    });

export const selectStoryGuid = (key: FullscreenLayoutAreas) =>
    createSelector(
        selectFullscreenState,
        selectSidecarCurrentStoryGuid(key),
        selectSidecarCurrentTopicStoryGuid(key),
        selectSidecarCurrentRundownSelectedStoryGuid(key),
        (fullScreenState, sideCarStoryGuid, sideCarTopicStoryGuid, sideCarRundownStoryGuid) => {
            return (fullScreenState.recordType === ObjectTypes.SCRIPT ? fullScreenState.recordGuid : null) || sideCarStoryGuid || sideCarTopicStoryGuid || sideCarRundownStoryGuid;
        }
    );

export const selectIsLockedSuccessfully = (key: FullscreenLayoutAreas) =>
    createSelector(selectStoryState, selectStoryGuid(key), (state, guid) => {
        return state.lockState.get(guid)?.state || false;
    });

export const selectIsLockedSuccessfullyByGuid = (guid: string) =>
    createSelector(selectStoryState, state => {
        return state.lockState.get(guid)?.state || false;
    });

// @TODO This can be checked trough sidecar states
export const selectHasLockedEditors = (guid: string) =>
    createSelector(selectStoryState, state => {
        return state.lockState.get(guid)?.editors?.length > 0 || false;
    });

export const selectIsLockingInProgress = (key: FullscreenLayoutAreas) =>
    createSelector(selectStoryState, selectStoryGuid(key), (state, guid) => {
        return state.lockInProgress.get(guid) || false;
    });

export const selectIsLockingInProgressByGuid = (guid: string) =>
    createSelector(selectStoryState, state => {
        return state.lockInProgress.get(guid) || false;
    });

export const selectShouldRequireLock = (key: FullscreenLayoutAreas) =>
    createSelector(selectStoryState, selectStoryGuid(key), (state, guid) => {
        return state.shouldRequireLock.get(guid) || false;
    });

export const selectShouldRequireLockByGuid = (guid: string) =>
    createSelector(selectStoryState, state => {
        return state.shouldRequireLock.get(guid) || false;
    });
